import { Select, SelectProps } from 'antd'

import { useLocales } from 'src/locales'

import { useClassifierElements } from '../../hooks/useClassifierElements'

type Props = {
  classifierId?: string
} & SelectProps<string | string[]>

/** Element(s) of a fișa classifier; only the ids are stored, the label is the translation. */
export const HivClassifierSelect = ({ classifierId, ...props }: Props) => {
  const { t, currentLang } = useLocales()
  const { elements, isLoading } = useClassifierElements(classifierId)

  const options = elements.map((element) => ({
    value: element.id,
    label: element.translation?.[currentLang.value]
  }))

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      loading={isLoading}
      placeholder={t('common.select_from_list')}
      options={options}
      {...props}
    />
  )
}
